





















import { Component, Vue, Prop } from "vue-property-decorator";
import { Document, Room } from "@/types";
import VideoParticipants from "@/components/room/VideoParticipants.vue";
import VideoPlayer from "@/components/room/VideoPlayer.vue";

import * as firebase from "firebase/app"; // for types
import * as twilio from "twilio-video";

@Component({ components: { VideoParticipants, VideoPlayer } })
export default class VideoGridSinging extends Vue {
  @Prop({ required: true })
  songAudioOutput!: AudioNode;

  @Prop({ required: true })
  audioCtx!: AudioContext;

  @Prop({ required: true })
  roomDoc!: Document<Room>;

  @Prop({ required: true })
  myId!: string;

  @Prop({ required: true })
  remoteParticipants!: twilio.RemoteParticipant[];

  @Prop({ required: true })
  localParticipant!: twilio.LocalParticipant;

  previousCurrentTime = 0;

  mounted() {
    const video = this.$refs.songVideo as VideoPlayer;

    video.$on("loadedmetadata", () => {
      this.roomDoc.ref.update({ currentVideoDuration: video.duration });
    });

    video.$on("play", () => {
      this.roomDoc.ref.update({ currentVideoPaused: false });
    });

    video.$on("pause", () => {
      this.roomDoc.ref.update({ currentVideoPaused: true });
    });

    video.$on("ended", () => {
      this.roomDoc.ref.update({
        currentSong: firebase.firestore.FieldValue.delete(),
        currentVideoTime: 0,
        currentVideoPaused: true,
      });
    });

    video.$on("timeupdate", (currentTime: number) => {
      if (Math.abs(currentTime - this.previousCurrentTime) >= 5) {
        this.roomDoc.ref.update({ currentVideoTime: currentTime });
        this.previousCurrentTime = currentTime;
      }
    });
  }

  get currentHref() {
    return window.location.href;
  }

  get currentSongUrl() {
    if (this.roomDoc.data.currentSong) {
      return this.roomDoc.data.currentSong.url;
    } else {
      return null;
    }
  }
}
